import { render } from "./content.svg?vue&type=template&id=e404c77c"
const script = {}
script.render = render

export default script